export default __webpack_public_path__ + "93b97b7e8bc16835287fdbf156b2f5c5.gif";